import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {DrinkMachineStorageService} from "../Services/DrinkMachineService/drink-machine-config-service";

@Component({
  selector: 'app-fill-machine',
  templateUrl: './fill-machine.component.html',
  styleUrls: ['./fill-machine.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FillMachineComponent implements OnInit {

  constructor(private _drinkMachineStorageService: DrinkMachineStorageService) { }

  ngOnInit() {
  }


  /**
   *
   * fill the coin in the machine
   *
   * @param coinValue
   */
  fillTheCoins(coinValue:number){

    this._drinkMachineStorageService.fillMachineCoins(coinValue);

  }


}



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/app/fill-machine/fill-machine.component.ts